let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cM3gY")).then(() => parcelRequire('fvvbN'));